let environment = 'development'
if (typeof document !== 'undefined' && document.documentElement && document.documentElement.dataset && document.documentElement.dataset.environment) {
  environment = document.documentElement.dataset.environment
}
export default environment
